module.exports = __webpack_public_path__ + "static/media/vijay.423a8a80.svg";